export const localizationsFields = `
  locales: _locales
  localizations: _localizations {
    typename: __typename
    locale: _locale
    slug: _slug
  }
`;
